import { render, staticRenderFns } from "./PropostaEditDesembolso.vue?vue&type=template&id=9e0c9794"
import script from "./PropostaEditDesembolso.vue?vue&type=script&lang=js"
export * from "./PropostaEditDesembolso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports